import React, { useEffect, useRef } from "react";
import "./CustomCursor.css";

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const cursorTwoRef = useRef(null);

  useEffect(() => {
    const moveCursor = (e) => {
      if (cursorRef.current && cursorTwoRef.current) {
        cursorRef.current.style.transform = `translate3d(calc(-50% + ${e.clientX}px), calc(-50% + ${e.clientY}px), 0)`;
        cursorTwoRef.current.style.left = `${e.clientX}px`;
        cursorTwoRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener("mousemove", moveCursor);
    return () => {
      document.removeEventListener("mousemove", moveCursor);
    };
  }, []);

  return (
    <>
      <div className="custom-cursor__cursor" ref={cursorRef}></div>
      <div className="custom-cursor__cursor-two" ref={cursorTwoRef}></div>
    </>
  );
};

export default CustomCursor;
